import { createAction, union } from '@ngrx/store';
import { Restaurant } from 'src/app/models/restaurant/restaurant';
import { LoadingState } from './restaurant.reducer';

export const updateLoadingState = createAction(
  'RestaurantActions updateLoadingState',
  (payload: LoadingState) => ({ payload }),
);

export const storeRestaurant = createAction(
  'RestaurantActions storeRestaurant',
  (payload: Restaurant) => ({ payload }),
);

export const storeSeats = createAction(
  'RestaurantActions storeSeats',
  (payload: number) => ({ payload }),
);

export const storeSelectedTimeSlotId = createAction(
  'RestaurantActions storeSelectedTimeSlotId',
  (payload: string) => ({ payload }),
);

export const resetState = createAction('RestaurantActions resetState');

const all = union({
  updateLoadingState,
  storeRestaurant,
  storeSeats,
  storeSelectedTimeSlotId,
  resetState,
});

export type RestaurantActionsUnion = typeof all;
